/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from "react";


const Prompt = (content, label, dir) => {
  const align = dir === "rtl" ? "right" : "left";
  const unicodeBidi = dir === "rtl" ? "bidi-override" : "normal";

  const styles = {
    prompt: {
      display: "flex",
      flexDirection: "column",
      alignItems: "left",
      width: "100%",
      marginBottom: "0.25in",
      paddingLeft: "0.5in",
      paddingRight: "0.5in",
    },
    promptlabel: {
      textAlign: "left",
      fontSize: "10pt",
      color: "#666",
      marginBottom: "0.125in",
    },
    promptcontent: {
      fontSize: dir === "rtl" ? "14pt" : "12pt",
      textAlign: align,
      unicodeBidi: "isolate",
    },
  };

  // clear up all whitespace characters and replace with a single space
  content = content.replace(/\s+/g, " ");
  // remove leading and trailing whitespace
  content = content.replace(/^[\s\n]+|[\s\n]+$/g, "");
  // remove all html tags
  content = content.replace(/<[^>]*>/g, "");
  // remove non-breaking spaces
  content = content.replace(/&nbsp;/g, "");

  return (
    <div style={styles.prompt}>
      <p style={styles.promptlabel}>{label}:</p>
      <p style={styles.promptcontent}>{content}</p>
    </div>
  );
};

export default Prompt;
